import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-31b6e762"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "holder holder-fluid"
};
const _hoisted_2 = {
  class: "header-block"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "left"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "mob-nav-icon"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mob-nav-block"
})], -1));

const _hoisted_6 = {
  class: "right"
};
const _hoisted_7 = {
  class: "header-nav"
};
const _hoisted_8 = {
  class: "header-nav-list"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Купить ");

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Продать ");

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" О нас ");

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Контакты ");

const _hoisted_13 = {
  class: "header-nav"
};
const _hoisted_14 = {
  class: "header-nav-list"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Авторы ");

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Работы ");

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Подборки ");

const _hoisted_18 = {
  key: 0
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" О нас ");

const _hoisted_20 = {
  key: 1
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Контакты ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_logo_icon = _resolveComponent("logo-icon");

  const _component_router_link = _resolveComponent("router-link");

  const _component_search_component = _resolveComponent("search-component");

  const _component_login_button_component = _resolveComponent("login-button-component");

  const _component_registration_button_component = _resolveComponent("registration-button-component");

  return _openBlock(), _createElementBlock("header", {
    class: "header",
    style: _normalizeStyle(_ctx.$route.name === 'contacts' ? {
      border: 'none'
    } : {})
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_router_link, {
    to: {
      name: 'main'
    },
    class: "header-logo"
  }, {
    default: _withCtx(() => [_createVNode(_component_logo_icon)]),
    _: 1
  }), _createVNode(_component_search_component, {
    class: "search"
  })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("ul", _hoisted_8, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'what-offer'
    }
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'sell-work'
    }
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'about'
    }
  }, {
    default: _withCtx(() => [_hoisted_11]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'contacts'
    }
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  })])])]), _createVNode(_component_login_button_component, {
    class: "login-button"
  }), _createVNode(_component_registration_button_component, {
    class: "registration-button"
  })])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("ul", _hoisted_14, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'authors'
    }
  }, {
    default: _withCtx(() => [_hoisted_15]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'works'
    }
  }, {
    default: _withCtx(() => [_hoisted_16]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'compilations'
    }
  }, {
    default: _withCtx(() => [_hoisted_17]),
    _: 1
  })]), _ctx.$isMobile() ? (_openBlock(), _createElementBlock("li", _hoisted_18, [_createVNode(_component_router_link, {
    to: {
      name: 'about'
    }
  }, {
    default: _withCtx(() => [_hoisted_19]),
    _: 1
  })])) : _createCommentVNode("", true), _ctx.$isMobile() ? (_openBlock(), _createElementBlock("li", _hoisted_20, [_createVNode(_component_router_link, {
    to: {
      name: 'contacts'
    }
  }, {
    default: _withCtx(() => [_hoisted_21]),
    _: 1
  })])) : _createCommentVNode("", true)])])]), _createVNode(_component_search_component, {
    class: "search-mobile"
  })])], 4);
}